import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Spinner } from "@/components/ui/spinner";
import { ScanSearch, User } from "lucide-react";

interface InsightsProcessingProps {
  activePrompt: string;
}

export const InsightsProcessing = ({ activePrompt }: InsightsProcessingProps) => {
  const useActivePrompt = activePrompt?.trim().length > 0 ? activePrompt : "How many students struggled with managing budgets for business continuity in their last assessment?...";
  return (
    <div className="flex pt-32">
      <div className="mx-auto min-w-[600px] max-w-[760px] px-10">
        <div className="flex items-start justify-between gap-2">
          <p className="mr-20 text-sm">{useActivePrompt}</p>
          <Badge className="shrink-0 mt-2">
            User <User className="w-4 h-4" />
          </Badge>
        </div>

        <Separator className="my-6" />

        <div className="flex items-start justify-between gap-8">
          <Badge variant="outline" className="mt-2">
            Search mode
            <ScanSearch />
          </Badge>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Spinner className="size-3.5 opacity-70" />
            <p>Reviewing submissions...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
